module.exports = __webpack_public_path__ + "img/防风.0b67f6fe.jpg";